var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('publicHead',{attrs:{"background":_vm.bg,"title":"走进佳驰","en-title":"ENTERING JIACHI","list":['关于佳驰','发展大事记','合作伙伴']},on:{"check":_vm.check}}),_c('div',{staticClass:"wrap"},[_c('index',{attrs:{"id":"index"}}),_c('history',{attrs:{"id":"history"}}),_c('cooperative',{attrs:{"id":"cooperative"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }